import { EphemeralDashboardTokenService } from '@qdrant/qdrant-cloud-public-api/serverless/space/auth/v1/ephemeral_dashboard_token';
import { createEphemeralDashboardToken } from '@qdrant/qdrant-cloud-public-api/serverless/space/auth/v1/ephemeral_dashboard_token/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';
import { ONE_HOUR_MILLISECONDS } from '@/utils/constants';

// A token lives 2 hours and every mint is audited. Re-minted 1 minute before it expires; a token that still
// expires in flight answers 401, and `spaceTokenMiddleware` re-mints it and retries.
const TOKEN_STALE_MS = 2 * ONE_HOUR_MILLISECONDS - 60_000;

export const spaceDashboardTokenService = createServiceQueries(EphemeralDashboardTokenService, {
  // The `api-key` a space's REST endpoint accepts, minted on demand by `spaceTokenMiddleware`.
  createEphemeralDashboardTokenQuery: (params) => ({
    ...queryOptions(createEphemeralDashboardToken, params, { transport }),
    staleTime: TOKEN_STALE_MS,
    gcTime: TOKEN_STALE_MS,
  }),
});
